module.exports = __webpack_public_path__ + "img/bbee_logo.11ee370e.png";